<nav data-test="breadcrumbs">
  @for (crumb of crumbs$ | async; let index = $index; let last = $last; track crumb.label) {
    <span [ngClass]="{ last: last }" [attr.data-test]="'breadcrumbs--' + index">
      <a [routerLink]="crumb.link" [innerHTML]="crumb.label" [ngClass]="{ last: last }"></a>
    </span>
  }
  @if (!displayTitle) {
    <span [attr.data-test]="'breadcrumbs--title'">
      <div>{{ title$ | async }}</div>
    </span>
  }
</nav>
